import React from 'react';
import '../styles/MainContainer.css';
import './Prices.css';
import ParticipantGroupPriceTable from '../prices/ParticipantGroupPriceTable';
import AddOnCatalog from '../add-on/AddOnCatalog';

/**
 * Price list /prices ("Preisliste", every signed-in user, offline readable): the entry price per participant group
 * (read-only, edited on /groups) and the add-on catalog "Zusätze" (admins create/edit/delete, everyone else reads).
 * Both lists come from shared, offline-cached loaders (useParticipantGroups, useAddOns).
 */
function Prices() {
  return (
    <div className="pricesPage">
      <ParticipantGroupPriceTable />
      <AddOnCatalog />
    </div>
  );
}

export default Prices;
